export const hasWildcardResponse = (userResponse) =>
  String(userResponse || '')
    .split(' / ')
    .some((part) => part.trim() === '*');

export const getFlowsWildcardError = (triggerType, userResponse, flowTemplateId) =>
  triggerType === 'flows' && hasWildcardResponse(userResponse) && !flowTemplateId
    ? 'Con * (cualquier respuesta) debes elegir la plantilla esperada.'
    : null;
